import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SplashImage from 'assets/Splash.png';
import { ReactComponent as HomePageLogo } from 'assets/SpeedchainMobileLogo.svg';
import { useNativeStatusBarStyle } from 'app/pages/mobile/hooks/useNativeStatusBarStyle';
import { NATIVE_SAFE_TOP } from 'app/pages/mobile/utils/constants';

function MobilePage(): JSX.Element {
  const navigate = useNavigate();
  useNativeStatusBarStyle('light');
  const { t } = useTranslation();

  const handleSignInClick = () => {
    navigate('/login');
  };

  return (
    <Box
      sx={{
        // Mobile container - full viewport
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'radial-gradient(60.77% 50% at 49.87% 50%, #3367CC 0%, #141F33 100%)',
        overflow: 'hidden',
        // PWA safe area support
        paddingLeft: 'env(safe-area-inset-left, 0px)',
        paddingRight: 'env(safe-area-inset-right, 0px)',
        paddingBottom: 'max(env(safe-area-inset-bottom, 0px), clamp(50px, 11vh, 90px))',
        // Center the logos
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      {/* Home page logo above - positioned absolutely at top */}
      <HomePageLogo
        style={{
          position: 'absolute',
          top: `calc(clamp(35px, 9vh, 70px) + ${NATIVE_SAFE_TOP})`,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 'clamp(200px, 40vw, 300px)',
          height: 'auto',
          maxWidth: '80%',
          maxHeight: '40vh',
          zIndex: 1,
        }}
      />

      {/* Sign in button */}
      <Button
        variant="outlined"
        onClick={handleSignInClick}
        sx={{
          position: 'relative',
          zIndex: 1,
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '8px',
          backgroundColor: 'white',
          backdropFilter: 'blur(10px)',
          color: 'white',
          px: 4,
          py: 1.5,
          minWidth: '300px',
          mt: 2,
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(255, 255, 255, 0.5)',
          },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: '#324C80',
            textAlign: 'center',
            fontFamily: '"SF Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            fontSize: '16px',
            fontWeight: 450,
            lineHeight: '24px',
          }}
        >
          {t('mobileSignInButton')}
        </Typography>
      </Button>

      {/* Splash image below - positioned to fill screen */}
      <Box
        component="img"
        src={SplashImage}
        alt="Construction Splash Image"
        sx={{
          position: 'absolute',
          top: '-40px',
          left: 0,
          width: '100vw',
          height: 'calc(100vh + 40px)',
          objectFit: 'cover',
          zIndex: 0,
        }}
      />
    </Box>
  );
}

export default MobilePage;
